import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiMessageCircle, FiPhone, FiPrinter, FiMapPin, FiMail } from 'react-icons/fi';

const locations = [
  {
    city: "桃園公司 (工廠)",
    line: "@k8057",
    tel: ["03 - 490 1420", "03 - 490 1490"],
    address: "桃園市平鎮區雙福路一段 13 號",
    email: "4901420@gmail.com"
  },
  {
    city: "台中公司",
    line: "@kaf4237s",
    tel: ["04 - 2463 2798", "04 - 2463 3739"],
    address: "台中市西屯區安林路23之7號",
    email: "conet.tai@msa.hinet.net"
  },
  {
    city: "高雄公司",
    line: "@dzx6075t",
    tel: ["07 - 374 5873", "07 - 374 2073"],
    address: "高雄市仁武區大春二街72-1號",
    email: "kconet@gmail.com"
  }
];

export default function ContactSection() {
  return (
    <section id="contact" className="py-20 bg-slate-900 text-white relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl -translate-x-1/2 translate-y-1/2"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">全區聯絡服務資訊</h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto rounded-full mb-6"></div>
          <p className="text-slate-400 max-w-2xl mx-auto">
            我們在北中南皆設有服務據點，為您提供最即時、專業的在地服務。歡迎隨時與我們聯繫。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {locations.map((loc, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              className="bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-8 hover:bg-slate-800 transition-colors"
            >
              <h3 className="text-2xl font-bold text-amber-400 mb-6 border-b border-slate-700 pb-4">
                {loc.city}
              </h3>
              
              <ul className="space-y-4">
                <li className="flex items-start gap-4">
                  <SafeIcon icon={FiMessageCircle} className="text-green-400 text-xl shrink-0 mt-1" />
                  <div>
                    <span className="block text-xs text-slate-400 mb-1">Line ID</span>
                    <span className="font-medium tracking-wide">{loc.line}</span>
                  </div>
                </li>
                
                <li className="flex items-start gap-4">
                  <SafeIcon icon={FiPhone} className="text-amber-500 text-xl shrink-0 mt-1" />
                  <div>
                     <span className="block text-xs text-slate-400 mb-1">電話</span>
                     {loc.tel.map((t, i) => <span key={i} className="block font-medium">{t}</span>)}
                  </div>
                </li>

                <li className="flex items-start gap-4">
                  <SafeIcon icon={FiMapPin} className="text-rose-400 text-xl shrink-0 mt-1" />
                  <div>
                    <span className="block text-xs text-slate-400 mb-1">地址</span>
                    <span className="font-medium">{loc.address}</span>
                  </div>
                </li>

                <li className="flex items-start gap-4">
                  <SafeIcon icon={FiMail} className="text-blue-400 text-xl shrink-0 mt-1" />
                  <div>
                    <span className="block text-xs text-slate-400 mb-1">Email</span>
                    <a href={`mailto:${loc.email}`} className="font-medium hover:text-amber-400 transition-colors break-all">
                      {loc.email}
                    </a>
                  </div>
                </li>
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}